import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Mega Pack después de comprar?',
  a: 'Recibirás el acceso al material de forma inmediata para que puedas empezar a usarlo cuanto antes, sin esperas ni trámites.'
}, {
  q: '¿Para qué nivel educativo está pensado?',
  a: 'El Mega Pack está diseñado para docentes de educación secundaria, bachillerato, preparatoria y primer ciclo universitario de toda Latinoamérica. Los contenidos son adaptables a grupos de 13 a 22 años aproximadamente.'
}, {
  q: '¿Sirve para cualquier país hispanohablante?',
  a: 'Sí. Todo el material está escrito en español latino neutro, sin regionalismos. Los ejemplos incluyen casos de México, Colombia, Chile, Argentina, Perú, Venezuela, Ecuador y toda la región. Está pensado específicamente para el aula latinoamericana.'
}, {
  q: '¿El material es editable?',
  a: 'El material se entrega en formato PDF listo para usar. Podés proyectarlo en el aula, compartirlo con tus alumnos o imprimirlo según tu preferencia.'
}, {
  q: '¿En qué moneda voy a pagar?',
  a: 'Pagás en tu moneda local. El sistema detecta automáticamente tu país y convierte el precio. Sin sorpresas ni conversiones manuales.'
}, {
  q: '¿Qué incluye la oferta especial de 27,90?',
  a: 'Incluye el Mega Pack completo (4 tomos + 4 bonos) más el Mega Pack Maestro Avanzado (3 tomos de Semiótica y Análisis del Discurso + recursos extra). Es el ecosistema completo para el docente que quiere llevar su enseñanza al nivel de especialización.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés 7 días de garantía total. Si por cualquier motivo sentís que el material no cumplió lo que prometimos, te devolvemos el 100% de tu dinero sin preguntas ni formularios.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark-card" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <div className="text-center mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-82">
            ❓ Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83">
          {faqs.map((faq, index) => <div key={index} className="bg-black border border-dark-border rounded-xl overflow-hidden" data-id="element-84">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85">
                <span className="font-bold text-lg text-white pr-8" data-id="element-86">
                  {faq.q}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" />
              </button>

              <AnimatePresence data-id="element-88">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89">
                    <div className="px-6 pb-5 text-gray-300 border-t border-dark-border/50 pt-4" data-id="element-90">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}